import React from "react";
import { Row, Col, Form, Input } from "antd";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

function ControlledInputField({
  name,
  control,
  label,
  placeholder = "",
  rules = {},
  errors,
  required = false,
}) {
  return (
    <Form.Item
      label={label}
      required={required}
      validateStatus={errors[name] ? "error" : ""}
      help={errors[name]?.message}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => <Input {...field} placeholder={placeholder} />}
      />
    </Form.Item>
  );
}

ControlledInputField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rules: PropTypes.object,
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
};

export default function ProfessionalIdentityFields({
  t,
  control,
  errors,
  getValues,
  keys,
}) {
  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <ControlledInputField
            name="firstname"
            control={control}
            errors={errors}
            label={t(keys.labelFirstName)}
            placeholder={t(keys.placeholderFirstName)}
            required
            rules={{
              required: t(keys.errorRequiredFirstName),
              minLength: { value: 2, message: t(keys.errorFirstNameMinLength) },
            }}
          />
        </Col>

        <Col span={12}>
          <ControlledInputField
            name="lastname"
            control={control}
            errors={errors}
            label={t(keys.labelLastName)}
            placeholder={t(keys.placeholderLastName)}
            required
            rules={{
              required: t(keys.errorRequiredLastName),
              minLength: { value: 2, message: t(keys.errorLastNameMinLength) },
            }}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <ControlledInputField
            name="email"
            control={control}
            errors={errors}
            label={t(keys.labelEmail)}
            placeholder={t(keys.placeholderEmail)}
            required
            rules={{
              required: t(keys.errorRequiredEmail),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: t(keys.errorInvalidEmailFormat),
              },
            }}
          />
        </Col>

        <Col span={12}>
          <ControlledInputField
            name="confirmEmail"
            control={control}
            errors={errors}
            label={t(keys.labelConfirmEmail)}
            placeholder={t(keys.placeholderConfirmEmail)}
            required
            rules={{
              required: t(keys.errorRequiredEmailConfirmation),
              validate: (value) =>
                value === getValues("email") || t(keys.errorEmailMismatch),
            }}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <ControlledInputField
            name="phoneNumber"
            control={control}
            errors={errors}
            label={t(keys.labelPhoneNumber)}
            placeholder={t(keys.placeholderPhoneNumber)}
            required
            rules={{
              required: t(keys.errorRequiredPhoneNumber),
              pattern: {
                value: /^[0-9+\s-]{8,}$/,
                message: t(keys.errorInvalidPhoneNumber),
              },
            }}
          />
        </Col>
      </Row>
    </>
  );
}

ProfessionalIdentityFields.propTypes = {
  t: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  keys: PropTypes.shape({
    labelFirstName: PropTypes.string.isRequired,
    placeholderFirstName: PropTypes.string.isRequired,
    errorRequiredFirstName: PropTypes.string.isRequired,
    errorFirstNameMinLength: PropTypes.string.isRequired,
    labelLastName: PropTypes.string.isRequired,
    placeholderLastName: PropTypes.string.isRequired,
    errorRequiredLastName: PropTypes.string.isRequired,
    errorLastNameMinLength: PropTypes.string.isRequired,
    labelEmail: PropTypes.string.isRequired,
    placeholderEmail: PropTypes.string.isRequired,
    errorRequiredEmail: PropTypes.string.isRequired,
    errorInvalidEmailFormat: PropTypes.string.isRequired,
    labelConfirmEmail: PropTypes.string.isRequired,
    placeholderConfirmEmail: PropTypes.string.isRequired,
    errorRequiredEmailConfirmation: PropTypes.string.isRequired,
    errorEmailMismatch: PropTypes.string.isRequired,
    labelPhoneNumber: PropTypes.string.isRequired,
    placeholderPhoneNumber: PropTypes.string.isRequired,
    errorRequiredPhoneNumber: PropTypes.string.isRequired,
    errorInvalidPhoneNumber: PropTypes.string.isRequired,
  }).isRequired,
};
